import React, { useEffect, useRef, useState } from "react";
import ModalPopup from "../../Common/Modal/Modal";
import { toast } from "react-toastify";
import { encryptVaultSecret } from "../../Common/Encrypt-Decrypt";
import {
  DeleteContact,
  SubmitContactData,
  UpdateContactSensitive,
  ValidateContactDeleteOtp,
  ValidateContactOtp,
  ValidateContactSensitiveOtp,
} from "../../../Api/SuperAdminVault/Contacts";

const getUserId = () => {
  return (
    sessionStorage.getItem("USER_ID") ||
    localStorage.getItem("USER_ID") ||
    "001"
  );
};

const ContactOtpModal = ({
  show,
  onClose,
  onVerified,
  contactId,
  payload,
  actionType,
}) => {
  const inputRefs = useRef([]);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(300);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    if (!show) return;

    setOtp(["", "", "", "", "", ""]);
    setTimer(300);

    setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 200);
  }, [show]);

  useEffect(() => {
    if (!show || timer <= 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [show, timer]);

  const formatTimer = () => {
    const min = String(Math.floor(timer / 60)).padStart(2, "0");
    const sec = String(timer % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  const handleChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(0, 1);

    const updatedOtp = [...otp];
    updatedOtp[index] = digit;
    setOtp(updatedOtp);

    if (digit && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  const resetOtpInputs = () => {
    setOtp(["", "", "", "", "", ""]);

    setTimeout(() => {
      inputRefs.current[0]?.focus();
    }, 200);
  };

  const handleVerify = async () => {
    const plainOtp = otp.join("");

    if (plainOtp.length !== 6) {
      toast.error("Enter valid 6 digit OTP");
      return;
    }

    setLoading(true);

    try {
      const encryptedOtp = await encryptVaultSecret(plainOtp);

      let response = null;

      if (actionType === "update_contact") {
        const payloads = {
          ...payload,
          otp: encryptedOtp,
          user_id: getUserId(),
        };

        response = await ValidateContactOtp(payloads, contactId);
      } else if (actionType === "contact_status") {
        const payloads = {
          status: payload?.status ?? false,
          user_id: getUserId(),
          otp: encryptedOtp,
        };

        response = await ValidateContactSensitiveOtp(payloads, contactId);
      } else if (actionType === "delete_contact") {
        const payloads = {
          otp: encryptedOtp,
          user_id: getUserId(),
        };

        response = await ValidateContactDeleteOtp(payloads, contactId);
      } else {
        toast.error("Invalid OTP action");
        return;
      }

      if (response?.message) {
        toast.success(response?.message || "OTP Verified");
        onVerified && onVerified(response);
      } else {
        toast.error("OTP verification failed");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async () => {
    if (timer > 0 || resendLoading) return;

    setResendLoading(true);

    try {
      let response = null;

      if (actionType === "update_contact") {
        response = await SubmitContactData(payload, contactId);
      } else if (actionType === "contact_status") {
        response = await UpdateContactSensitive(
          payload?.contact,
          payload?.status ?? false,
        );
      } else if (actionType === "delete_contact") {
        response = await DeleteContact(contactId, null, {}, false);
      } else {
        toast.error("Invalid resend OTP action");
        return;
      }

      if (response) {
        toast.success(response?.message || "OTP resent successfully");
        resetOtpInputs();
        setTimer(300);
      } else {
        toast.error("Unable to resend OTP");
      }
    } catch (error) {
      toast.error(error?.message || "Unable to resend OTP");
    } finally {
      setResendLoading(false);
    }
  };
  const getVerifyButtonText = () => {
    if (loading) {
      if (actionType === "update_contact") return "Updating...";
      if (actionType === "contact_status") return "Unlocking...";
      if (actionType === "delete_contact") return "Deleting...";
      return "Verifying...";
    }

    if (actionType === "update_contact") return "Verify & Update";
    if (actionType === "contact_status") return "Verify & Unlock";
    if (actionType === "delete_contact") return "Verify & Delete";

    return "Verify";
  };
  return (
    <ModalPopup show={show} onClose={onClose} closeicon={false}>
      <div className="h-full flex flex-col">
        <div className="flex items-center justify-between">
          <button
            className="bg-[#1f4b7f] text-white pl-4 pr-2 py-1 rounded-r-md back-button"
            onClick={onClose}
          >
            Back
          </button>

          {/* <button
            disabled={timer > 0 || resendLoading}
            onClick={handleResendOtp}
            className={`text-[1vw] ${
              timer > 0
                ? "text-[#1F487C] cursor-not-allowed"
                : "text-[#1F487C] cursor-pointer font-bold"
            }`}
          >
            {resendLoading
              ? "Resending..."
              : timer > 0
                ? `Resend OTP in ${formatTimer()}`
                : "Resend OTP"}
          </button> */}
        </div>

        <div className="flex flex-col items-center mt-[1.5vw]">
          <h1 className="text-[#1F487C] text-[1.5vw] font-bold">
            OTP Verification
          </h1>

          <p className="text-[1vw] mt-[1vw] text-black w-[24vw]">
            Enter the 6-digit OTP sent to your registered mobile number.
          </p>

          <div className="flex gap-[0.7vw] mt-[1.2vw]">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                value={digit}
                maxLength={1}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                className="w-[2.1vw] h-[2.1vw] text-center text-[1.2vw] border-[#9CA3AF] border-[0.12vw] rounded-[0.35vw] outline-none focus:border-[#1F487C]"
              />
            ))}
          </div>

          <button
            disabled={loading}
            onClick={handleVerify}
            className="bg-[#1F487C] text-white text-[1vw] px-[0.9vw] py-[0.45vw] rounded-[0.4vw] mt-[1vw]"
          >
            {getVerifyButtonText()}
          </button>
        </div>
      </div>
    </ModalPopup>
  );
};

export default ContactOtpModal;
